(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belitcar-b2b-landing"] && !Shopify.designMode) return;
  try {
    
  const belitcarSections = document.querySelectorAll('[data-belitcar-landing]');

  belitcarSections.forEach((section) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = section.querySelectorAll('[data-reveal]');
    const parallaxItems = section.querySelectorAll('[data-parallax]');
    const progress = section.querySelector('.belitcar-scroll-progress');
    let ticking = false;

    if (reduceMotion || revealItems.length === 0) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      if (progress) progress.style.setProperty('--scroll-progress', 1);
      return;
    }

    section.classList.add('belitcar-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );

    revealItems.forEach((item, index) => {
      item.style.setProperty('--reveal-delay', `${Math.min(index % 6, 5) * 70}ms`);
      observer.observe(item);
    });

    const updateScrollMotion = () => {
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollProgress = documentHeight > 0 ? window.scrollY / documentHeight : 0;
      if (progress) progress.style.setProperty('--scroll-progress', Math.max(0, Math.min(1, scrollProgress)));

      parallaxItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const distance = (center - window.innerHeight / 2) / window.innerHeight;
        const offset = Math.max(-18, Math.min(18, distance * -26));
        item.style.setProperty('--parallax-y', `${offset}px`);
      });

      ticking = false;
    };

    const requestScrollMotion = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollMotion);
    };

    updateScrollMotion();
    window.addEventListener('scroll', requestScrollMotion, { passive: true });
    window.addEventListener('resize', requestScrollMotion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charge-factory-delivery-review"] && !Shopify.designMode) return;
  try {
    
function initChargeFactoryDeliveryReview(){
  const form=document.getElementById('CFDeliveryReview');
  if(!form||form.dataset.reviewReady)return;
  form.dataset.reviewReady='true';
  const key='cf-delivery-review-v2';
  const success=form.querySelector('.cf-review-success');
  if(success){try{sessionStorage.removeItem(key);}catch(e){}success.focus();return;}
  let context=null;
  try{context=JSON.parse(sessionStorage.getItem(key)||'null');}catch(e){}
  const valid=context&&typeof context.name==='string'&&context.name.trim()&&context.name.length<=160&&typeof context.order==='string'&&/^#[0-9A-Za-z_-]{1,40}$/.test(context.order)&&typeof context.email==='string'&&/^\S+@\S+\.\S+$/.test(context.email)&&context.email.length<=254&&Number.isFinite(context.created)&&Date.now()-context.created>=0&&Date.now()-context.created<7200000;
  if(!valid){try{sessionStorage.removeItem(key);}catch(e){}return;}
  const fields={name:form.querySelector('#cf-review-name'),order:form.querySelector('#cf-review-order'),email:form.querySelector('#cf-review-email')};
  Object.keys(fields).forEach(k=>{fields[k].value=context[k];});
  form.querySelector('#cf-review-customer-display').textContent=context.name;
  form.querySelector('#cf-review-order-display').textContent='Pedido '+context.order;
  form.querySelector('#cf-review-email-display').textContent=context.email;
  form.querySelector('#cf-review-link-needed').hidden=true;
  form.querySelector('#cf-review-personalized').hidden=false;
  const score=new URLSearchParams(window.location.search).get('rating');
  if(/^[1-5]$/.test(score||'')){
    const input=form.querySelector('#cf-review-score-'+score);
    if(input&&!form.querySelector('input[type="radio"]:checked'))input.checked=true;
  }
  form.addEventListener('submit',()=>{Object.keys(fields).forEach(k=>{fields[k].value=context[k];});});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initChargeFactoryDeliveryReview);else initChargeFactoryDeliveryReview();
document.addEventListener('shopify:section:load',initChargeFactoryDeliveryReview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charge-factory-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.cf-site');
    if (!root) return;
    const hero = root.querySelector('.cf-hero');
    if (hero && 'IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver((entries) => {
        root.classList.toggle('cf-hero-active', entries[0].intersectionRatio > 0.01);
      }, { threshold: 0.01 });
      heroObserver.observe(hero);
    } else {
      root.classList.remove('cf-hero-active');
    }
    const revealed = root.querySelectorAll('[data-cf-reveal]');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('cf-visible'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.08 });
      revealed.forEach((element) => observer.observe(element));
    } else {
      revealed.forEach((element) => element.classList.add('cf-visible'));
    }
    root.querySelectorAll('.cf-mobile-menu nav a').forEach((link) => link.addEventListener('click', () => {
      const menu = root.querySelector('.cf-mobile-menu');
      if (menu) menu.open = false;
    }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
